import { Component } from 'react';

class SearchForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            awards: [],
            search: "",
        }
        if (this.props.defaultReferenceNo){
          this.setState({search: this.props.defaultReferenceNo});
        }
    }

    render() {
        return (
            <div className="emc-search-container">
            <form className="emc-form" onSubmit={this.props.handleSearch}>
              <input
                id="search"
                name="search"
                type="text"
                placeholder="e-MC Document ID"
                value={this.state.search}
                onChange={(e) => {this.setState({search: e.target.value})}}
                className="verify-input"
              />
              <button type="submit" className="verify-btn">Verify</button>
            </form>
          </div>

        )
    }
}

export default SearchForm;
